import colors from '@theme/colors';
import { scale } from '@utils/normalize';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.neutral.cotton,
    paddingHorizontal: scale(24),
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: scale(32),
  },
  illustrationContainer: {
    alignItems: 'center',
    marginBottom: scale(24),
  },
  illustrationCircle: {
    width: scale(120),
    height: scale(120),
    borderRadius: scale(60),
    backgroundColor: colors.secondary.darkOrchid,
    justifyContent: 'center',
    alignItems: 'center',
  },
  headline: {
    marginBottom: scale(8),
  },
  description: {
    marginBottom: scale(8),
  },
  errorText: {
    textAlign: 'center',
    marginTop: scale(8),
    marginBottom: scale(8),
  },
  ctaButton: {
    marginTop: scale(8),
    borderRadius: scale(8),
  },
});

export default styles;
